export default "Golf & Fun Park åbnede i 2015.";